<template>
  <div
    class="content padding24 mapContentBox"
    v-if="$route.name == 'SourceMap'">
    <source-top
      :query="queryInfo"
      :mapNum="mapNum"
      @filterMap="changeMapTimers"></source-top>
    <div
      class="listBox"
      v-if="show">
      <router-view
        style="width: 100%"
        :data="result"
        :sourceObj="result.list"
        :mapQueryObj="mapQueryObj"
        @mapNumChange="getMapNum"></router-view>
    </div>
  </div>
  <div
    class="content padding24 mapContentBox"
    v-else-if="$route.name == 'SourceMapTrack'">
    <!-- <track-top
      :query="queryInfo"
      :mapNum="mapNum"
      @changeTimeType='changeTimeType'
      @changeTrack='changeTrack'
      @filterMap="changeMapTimers"></track-top> -->
    <component
      :is='trackTopWrap'
      v-if="trackTopWrap"
      :query="queryInfo"
      :mapNum="mapNum"
      @changeTimeType='changeTimeType'
      @changeTrack='changeTrack'
      @filterMap="changeMapTimers"
    ></component>
    <router-view
      :data="result"
      :initDeviceList="initDeviceList"
      :sourceObj="result.list"
      :mapQueryObj="mapQueryObj"
      :imgUrlTime="imgUrlTime"
      :page="'hm'"
      :tracking='tracking'
      @mapNumChange="getMapNum"></router-view>
  </div>
  <div
    class="content padding24"
    v-else>
    <source-top
      :query="queryInfo"
      :mapNum="mapNum"
      @filterMap="changeMapTimers"
      @sendMySourceSockect="sendMySourceSockect"></source-top>
    <div
      class="listBox"
      v-loading="!show"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <div
        style="width: 100%"
        v-if="show">
        <router-view
          :data="result"
          :initDeviceList="initDeviceList"
          :sourceObj="result.list"
          :mapQueryObj="mapQueryObj"
          :imgUrlTime="imgUrlTime"
          :page="'hm'"
          @mapNumChange="getMapNum"></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import SourceTop from './sourceTop' // 顶部搜索部分
import { mapState, mapMutations } from 'vuex'
import Bus from '@/assets/js/vueBus.js'
import { addMediaJs, handleRlist } from '@/assets/js/shareCommon.js'
// import TrackTop from './trackTop'
const trackTopComponent = () => import('./trackTop')
export default {
  components: {
    SourceTop
    // TrackTop
  },
  data () {
    return {
      loading: false,
      result: {
        allSourceData: {}
      },
      allSourceData: {},
      show: false,
      peerIds: '', // 所有的source id
      btn: false,
      routeName: '',
      mapNum: {},
      mapQueryObj: {},
      pageMsgWebsocket: {},
      liveRids: [],
      shareData: [],
      ifOpenMediaService: this.$store.state.common.baseUrl.mediaControl.mySource || false,
      initCurrentInfoSocket: true,
      curDeviceList: [], // 当前的设备列表
      imgTimer: null,
      imgUrlTime: {
        current: {},
        last: {}
      },
      initDeviceList: [],
      timeType: null,
      tracking: {},
      trackTopWrap: null
    }
  },
  async created () {
    Bus.$on('changeFilter', (data) => {
      this.show = data
    })
    Bus.$on('loadingConfigT', (data) => {
      this.loading = data
    })
    Bus.$on('updateEventIcon', async (obj) => {
      const index = this.result.list.findIndex(v => v.peerId.toLowerCase() == obj.peerId.toLowerCase())
      const sourceItem = this.result.list[index]
      if (sourceItem) {
        sourceItem.isOnGoing = obj.tag == 'start'
        this.$set(this.result.list, index, sourceItem)
      }
      // if (this.$route.name == 'SourceMapTrack') {
      //   const trackTopWrap = await trackTopComponent()
      //   this.trackTopWrap = trackTopWrap.default
      // }
    })
  },
  mounted () {
    // media集成相关——加载公共js获取shareInfo
    if (this.ifOpenMediaService && this.$route.name == 'SourceContent') {
      addMediaJs('S', 'mySource', (shareData) => {
        this.shareData = shareData
        mediaObj.shareData = JSON.stringify(shareData.RInfo)
      })
    }
  },
  computed: mapState({
    State: (state) => state,
    pageRequest: (state) => state.websocket.pageRequest,
    pageRWebsocket: (state) => state.websocket.pageRWebsocket,
    openOnGoingEvent () {
      return this.$store.state.common.baseUrl.openOnGoingEvent
    }
  }),
  watch: {
    liveRids (val) {
      // 监听receiverlist的变化 用以停止currentRInfo 的websocket 防止数据获取不到
      if (val.length > 0) {
        // 开启websocket
        if (this.initCurrentInfoSocket) {
          this.createMsgWebsocket()
          this.updateParams()
          this.initCurrentInfoSocket = false
        }
      } else {
        // 关闭websocket
        this.initCurrentInfoSocket = true
        this.stopupdateParams()
      }
    },
    '$route.name': {
      async handler (val) {
        if (val == 'SourceMapTrack' && !this.trackTopWrap) {
          const trackTopWrap = await trackTopComponent()
          this.trackTopWrap = trackTopWrap.default
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('common', [
      'CURRENT_RINFO',
      'DEVICELIST_VOLUMECHARTDATA',
      'DEVICELIST_SLOTINFODATA',
      'DEVICELIST_RECEIVERDATADATA',
      'DEVICELIST_CURRENTRINFODATA',
      'DEVICELIST_SETINFODATA'
    ]),
    sendMySourceSockect (data) {
      // 但获取到当前R的id的时候 创建websocket
      this.initDeviceList = data && data.list
      this.imgUrlTime = {
        current: {},
        last: {}
      }
      if (data && !this.btn) {
        this.sendWebsocket(data)
        // 先立即获取一次缩略图
        this.thumbnailUpdate()
        this.initThumbnailWs()
      }
    },
    initThumbnailWs () {
      if (this.imgTimer) clearInterval(this.imgTimer)
      this.imgTimer = setInterval(() => {
        this.thumbnailUpdate()
      }, 5000)
    },
    changeMapTimers (obj) {
      this.mapQueryObj = obj
      this.show = true
    },
    changeTimeType (val) {
      this.timeType = val
    },
    changeTrack (val) {
      this.tracking.timeType = this.timeType
      this.tracking = val
    },
    getMapNum (obj) {
      this.mapNum = obj
    },
    queryInfo (val) {
      this.result = val
      this.allSourceData = {}
      const packList = []
      const anyWhereList = []
      const peerArr = []
      this.$store.state.packList = val.list
      val.list.map((item, index) => {
        peerArr.push(item.peerId)
        item.lastLiveName = ''
        this.allSourceData[item.peerId] = item
        if (item.type == 'T' && item.platform) {
          item.version = item.releaseStr || item.version
          if (item.platform < 10 || item.platform > 14) packList.push(item.peerId)
          if (item.platform >= 10 && item.platform <= 14) anyWhereList.push(item.peerId)
        }
        if (item.type == 'X') packList.push(item.peerId)
      })
      this.result.allSourceData = this.allSourceData
      this.result = Object.assign({}, this.result)
      this.show = true

      // onGoingEvent 及 Grid Log
      if (['SourceContent', 'SourceList'].includes(this.$route.name) && (packList.length || anyWhereList.length) && this.openOnGoingEvent) {
        this.getEventPerimission(packList, anyWhereList)
      }
      // 回显最后Live的R信息
      if (this.$route.name == 'SourceContent' || this.$route.name == 'SourceList') this.getLastLiveDevice(peerArr)
    },
    getLastLiveDevice (arr) {
      this.axios.post('/ccp/tvucc-device/device/getDeviceLastLivePidMsg', arr, {
        contentType: 'application/json;charset=UTF-8',
        isCancelToken: true
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result.length) {
            const resultArr = res.data.result
            resultArr.forEach(m => {
              if (this.result.allSourceData[m.peerId]) {
                this.result.allSourceData[m.peerId].lastLiveName = m.peerName
              }
            })
          }
        }
      }).catch(() => {})
    },
    getEventPerimission (packList, anyWhereList) {
      this.axios.post('/ccp/tvucc-user/userDevice/isUserOwnerByListPeerId', { anyWhereList, packList }, {
        contentType: 'application/json;charset=UTF-8',
        isCancelToken: true
      }).then(res => {
        const data = res.data.result
        data.forEach((item, i) => {
          const index = this.result.list.findIndex(v => v.peerId.toLowerCase() == item.peerId.toLowerCase())
          if (index >= 0) {
            const sourceItem = this.result.list[index]
            sourceItem.hasSlugPerimission = item.creatEvent
            sourceItem.isOnGoing = item.hasEndTime && !item.hasExpire && item.hasSlug
            sourceItem.showEventIcon = item.creatEvent || sourceItem.isOnGoing && !item.creatEvent
            this.$set(this.result.list, index, sourceItem)
          }
        })
      }).catch(() => {})
    },
    // 创建websocket
    createMsgWebsocket () {
      this.sendMsgWebsocket('VolumeChart', '2152867840', '200', 200) // 获取音量信息
      this.sendMsgWebsocket('SlotInfo', '2152865792', '101', 1000) // 获取slot信息
      this.sendMsgWebsocket('ReceiverData', '2152857600', '101', 1000) // 获取err and quality信息
      this.sendMsgWebsocket('CurrentRInfo', '2152857600', '102', 1000) // 获取type and format信息
      this.sendMsgWebsocket('SetInfo', '2152866048', '101', 1000) // 获取bitrate and delay信息
    },
    // 获取设备实时信息
    sendMsgWebsocket (type, categoryId, operationType, time) {
      let typeVal = ''
      if (type != 'VolumeChart') { typeVal = `${type[0].toLowerCase()}${type.slice(1, type.length)}` }
      this.pageRWebsocket && this.pageRWebsocket.send({
        message: {
          categoryId: categoryId,
          operationType: operationType,
          rid: this.liveRids.join(',')
        },
        time: time || 5000,
        key: typeVal || type,
        success: (res) => {
          this.updateDeviceDetailData(
            `deviceList${type}Data`,
            `DEVICELIST_${type.toUpperCase()}DATA`,
            res
          )
        }
      })
    },
    // 更新音柱和设备详情信息
    updateDeviceDetailData (deviceData, fn, data) {
      let deviceDetailArr = []
      let deviceDetailIdArr = []
      this.$store.state.common[deviceData].map((v, i) => {
        if (this.liveRids.includes(v.rid)) {
          deviceDetailArr.push(v)
          deviceDetailIdArr.push(v.rid)
        }
      })
      if (deviceDetailIdArr.includes(data.rid)) {
        deviceDetailArr[deviceDetailIdArr.indexOf(data.rid)] = data
      } else {
        deviceDetailArr.push(data)
      }
      this[fn](deviceDetailArr)
    },
    // 更新websocket参数
    updateParams () {
      if (this.liveRids.length <= 0) {
        // 正在live的R为空时，清空store中的数据
        this[`DEVICELIST_${'currentRInfo'.toUpperCase()}DATA`]([])
      }
      this.updateSocketParams('VolumeChart', '2152867840', '200') // 获取音量柱信息
      this.updateSocketParams('slotInfo', '2152865792', '101')
      this.updateSocketParams('receiverData', '2152857600', '101')
      this.updateSocketParams('currentRInfo', '2152857600', '102')
      this.updateSocketParams('setInfo', '2152866048', '101')
    },
    stopupdateParams () {
      // 停止获取数据
      if (this.$createWebsocket.pageRWebsocket) {
        this.$createWebsocket.pageRWebsocket('stop', [
          'VolumeChart',
          'slotInfo',
          'receiverData',
          'currentRInfo',
          'setInfo'
        ]) // 停止websocket
      }
    },
    // 更新websocket参数
    updateSocketParams (type, categoryId, operationType) {
      const message = {
        categoryId: categoryId,
        operationType: operationType,
        rid: this.liveRids.join(',')
      }
      if (this.pageRWebsocket.sendMsgs && this.pageRWebsocket.sendMsgs[type]) {
        this.pageRWebsocket.sendMsgs[type].message = message
      }
    },
    // 更新缩略图
    thumbnailUpdate () {
      if (!Array.isArray(this.curDeviceList)) return
      let peerIds = []
      // Grid Live时：mediaHubGrid从R端拿缩略图，普通Grid仍从自身拿
      this.curDeviceList.map((v) => {
        if (!v) return
        const isGridHub = v.type == 'X' && v.peerId && v.peerId.toLowerCase().endsWith('0000000000000003')
        if (v.status == 2 && (v.type != 'X' || isGridHub)) {
          peerIds.push((v.livePeerId || '').split(';')[0])
        } else {
          peerIds.push(v.peerId)
        }
      })
      if (!peerIds.length) return
      this.axios.post(`${location.protocol}//${this.$store.state.common.baseUrl.blobUrl.split('/')[0]}/thumbnailVersion`, peerIds, { headers: { 'Content-Type': 'application/json;charset=UTF-8' } })
        .then((res) => {
          this.imgUrlTime.last = this.imgUrlTime.current
          this.imgUrlTime.current = res.data
        }).catch(() => {})
    },
    sendWebsocket (data) {
      var sendParam = []
      this.peerIds = []
      this.curDeviceList = []
      if (data.list) {
        data.list.forEach((item) => {
          sendParam.push(item.peerId)
          this.curDeviceList.push(item)
        })
      }
      this.peerIds = sendParam
      if (this.$createWebsocket.pageRequest) {
        this.$createWebsocket.pageRequest('stop', 'taskInfo_T_S') // 停止websocket
      }
      this.pageRequest && this.pageRequest.send({
        message: {
          type: 'taskInfo',
          module: 'taskInfo_T_S',
          data: { peerIds: this.peerIds.join(',') }
        },
        time: 1000,
        key: 'taskInfo_T_S',
        success: (res) => {
          var results = res.result
          this.$store.state.packList = results
          this.liveRids = []
          this.curDeviceList = Array.isArray(results) ? JSON.parse(JSON.stringify(results)) : [] // 更新获取缩略图时间戳的参数
          if (results.length > 0) {
            let thisD = {}
            results.map((item) => {
              thisD[item.peerId] = item
              if (item.type.toLowerCase() == 'r') this.CURRENT_RINFO(item)
              // live的rid
              if (item.status == 2 && item.type.toLowerCase() != 'r') {
                if (item.gridLivePeerId != null) {
                  item.gridLivePeerId.split(';').map((v, i) => {
                    this.liveRids.push(v)
                  })
                } else {
                  this.liveRids.push(item.livePeerId)
                }
              }

              // 处理记录最后一次Live的R信息
              if (item.type.toLowerCase() != 'r') {
                const listFilter = this.result.allSourceData[item.peerId]
                if (listFilter) item.lastLiveName = listFilter.lastLiveName
              }
            })
            // 更新websocket参数
            this.updateParams()
            // media相关
            this.result.allSourceData = this.ifOpenMediaService && this.shareData.RInfo && this.shareData.RInfo.length > 0 ? handleRlist(this.shareData, thisD, 'S') : thisD
            this.allSourceData = this.ifOpenMediaService && this.shareData.RInfo && this.shareData.RInfo.length > 0 ? handleRlist(this.shareData, thisD, 'S') : thisD
            this.result = Object.assign({}, this.result)
            this.btn = true
          }
          let newParam = []
          if (this.result.list) {
            this.result.list.forEach((item) => {
              newParam.push(item.peerId)
            })
            newParam.push(this.$store.state.common.currentRid)
          }
          this.peerIds = newParam
          var taskInfoMsg = {
            type: 'taskInfo',
            module: 'taskInfo_T_S',
            data: { peerIds: this.peerIds.join(',') }
          }
          this.pageRequest.sendMsgs.taskInfo_T_S.message = taskInfoMsg
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    Bus.$off('changeFilter')
    Bus.$off('updateEventIcon')
    Bus.$off('loadingConfigT')
    this.imgTimer && clearInterval(this.imgTimer)
    if (this.$createWebsocket.pageRequest) {
      this.$createWebsocket.pageRequest('stop', 'taskInfo_T_S') // 停止websocket
    }
    if (this.$createWebsocket.pageRWebsocket) {
      this.$createWebsocket.pageRWebsocket('stop', [
        'VolumeChart',
        'slotInfo',
        'receiverData',
        'currentRInfo',
        'setInfo'
      ]) // 停止websocket
    }

    if (this.ifOpenMediaService && window.SM) {
      SM.__proto__.stopSocket()
    }

    next()
  },
  beforeDestroy () {
    this.imgTimer && clearInterval(this.imgTimer)
    if (this.$createWebsocket.pageRequest) {
      this.$createWebsocket.pageRequest('stop', 'taskInfo_T_S') // 停止websocket
    }
    if (this.$createWebsocket.pageRWebsocket) {
      this.$createWebsocket.pageRWebsocket('stop', [
        'VolumeChart',
        'slotInfo',
        'receiverData',
        'currentRInfo',
        'setInfo'
      ]) // 停止websocket
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 99.5%;
  padding-left: 0.5%;
  height: 100% !important;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  .top {
    max-height: 190px;
  }
  &.mapContentBox {
    padding-bottom: 0;
  }
  .listBox {
    flex: 1;
    // height: calc(100% - 94px);
  }
  @media (max-width: 1919px) {
    .listBox {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
